var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    className: "icon",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d42536",
    d: "m934.4 770.133-328.533-588.8C586.667 147.2 550.4 128 512 128c-38.4 0-74.667 21.333-93.867 53.333L89.6 770.133c-19.2 34.134-19.2 76.8 0 110.934s55.467 57.6 93.867 57.6h657.066c38.4 0 74.667-21.334 93.867-57.6 19.2-34.134 19.2-76.8 0-110.934zM878.933 851.2c-8.533 14.933-23.466 23.467-38.4 23.467H183.467c-14.934 0-29.867-8.534-38.4-23.467-8.534-14.933-8.534-34.133 0-49.067l328.533-588.8C482.133 200.533 497.067 192 512 192s29.867 8.533 38.4 21.333l328.533 588.8c8.534 14.934 8.534 32 0 49.067z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d42536",
    d: "M469.33299999999997 746.667a42.667 42.667 0 1 0 85.334 0 42.667 42.667 0 1 0-85.334 0ZM512 629.333c17.067 0 32-14.933 32-32v-192c0-17.066-14.933-32-32-32s-32 14.934-32 32v192c0 17.067 14.933 32 32 32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWarning);
export default __webpack_public_path__ + "static/media/delete-warning.8ca2ae4c1fd3bcda3c09254c6625a0a4.svg";
export { ForwardRef as ReactComponent };